import { render, staticRenderFns } from "./collectionCountByHour.vue?vue&type=template&id=5dcb022e"
import script from "./collectionCountByHour.vue?vue&type=script&lang=js"
export * from "./collectionCountByHour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports